export default __webpack_public_path__ + "images/logic-high-flag.svg";